import React from 'react'
import SVG from 'react-inlinesvg'
import SvgSprite from '@sm360/payment-calculator-360/dist/assets/svg-sprite.svg'

import { runtimeConfig } from '../config/runtimeConfig'

import ModalView from '../../views/modal/Modal.view'

class ModalSSR extends React.Component {
    render() {
        const svgBaseUrl = runtimeConfig.REACT_APP_ASSETS_PATH
            ? `${runtimeConfig.REACT_APP_ASSETS_PATH}/payment-calculator-360`
            : ''
        return (
            <>
                <SVG
                    src={`${svgBaseUrl}${SvgSprite}`}
                    style={{ display: 'none' }}
                    onError={(error) => console.log('svg error', error)}
                />

                <ModalView />
            </>
        )
    }
}

export default ModalSSR
